import { Box, Typography } from '@mui/material';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';

export default function PMgallery() {
  return (
    <Box
      sx={{
        width: '100%',
        height: '400px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'text.secondary',
        textAlign: 'center',
        p: 2,
      }}
    >
      <SentimentDissatisfiedIcon sx={{ fontSize: 60, mb: 2 }} />
      <Typography variant="h6">No Images Available</Typography>
      <Typography variant="body2">
        There are currently no images to display in this gallery.
      </Typography>
    </Box>
  );
}
